import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f17f18a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "在线客服", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_4 = { class: "input-field user-name" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "input-field password" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "dp-value" }
const _hoisted_9 = {
  key: 0,
  class: "dp-list"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "input-field call"
}
const _hoisted_12 = { class: "input-capcha-group" }
const _hoisted_13 = { class: "input-field shield-check" }
const _hoisted_14 = { class: "capcha-image-wrap" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "agree-info" }
const _hoisted_17 = { class: "button-group" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_service = _resolveComponent("i-service")!
  const _component_i_user = _resolveComponent("i-user")!
  const _component_i_lock = _resolveComponent("i-lock")!
  const _component_i_layer = _resolveComponent("i-layer")!
  const _component_i_arrow_l = _resolveComponent("i-arrow-l")!
  const _component_i_call = _resolveComponent("i-call")!
  const _component_i_sheild_check = _resolveComponent("i-sheild-check")!
  const _component_i_reload = _resolveComponent("i-reload")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "customer-service",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.contactService && _ctx.contactService(...args)))
    }, [
      _createVNode(_component_i_service, {
        "fill-color": '#e0d77f',
        class: "icon"
      }),
      _hoisted_2
    ]),
    _createElementVNode("form", {
      action: "",
      class: "form",
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doLogin && _ctx.doLogin(...args)), ["prevent"]))
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_i_user, { class: "icon" }),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.uname) = $event)),
          placeholder: _ctx.t('usernameplaceholder')
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.uname]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_i_lock, { class: "icon" }),
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pwd) = $event)),
          placeholder: _ctx.t('passwordplaceholder')
        }, null, 8, _hoisted_7), [
          [_vModelText, _ctx.pwd]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "input-field layer",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showLoginType = !_ctx.showLoginType), ["prevent"]))
      }, [
        _createVNode(_component_i_layer, { class: "icon" }),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.loginType.name), 1),
        _createVNode(_component_i_arrow_l, {
          class: _normalizeClass(["icon-arrow-l", { active: _ctx.showLoginType }])
        }, null, 8, ["class"]),
        _createVNode(_Transition, { name: "slide-down" }, {
          default: _withCtx(() => [
            (_ctx.showLoginType)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLoginType, (_loginType) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: _loginType.id,
                      onClick: ($event: any) => (_ctx.onSelectLoginType(_loginType))
                    }, _toDisplayString(_loginType.name), 9, _hoisted_10))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])), [
        [_directive_click_outside, _ctx.hideShowLoginType]
      ]),
      (_ctx.loginType.id === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_i_call, { class: "icon" }),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phoneNumber) = $event)),
              placeholder: "请输入电话号码"
            }, null, 512), [
              [_vModelText, _ctx.phoneNumber]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_i_sheild_check, { class: "icon" }),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.capchaInput) = $event)),
            placeholder: "请输入验证码",
            onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onCapchaKeydown && _ctx.onCapchaKeydown(...args)))
          }, null, 544), [
            [_vModelText, _ctx.capchaInput]
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", { src: _ctx.capchaSrc }, null, 8, _hoisted_15)
          ]),
          _createVNode(_component_i_reload, {
            class: "reload",
            onClick: _ctx.getImage
          }, null, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", {
          class: _normalizeClass(["cirle-indicator", { 'active': _ctx.agreed }]),
          onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.agreed = !_ctx.agreed), ["prevent"]))
        }, null, 2),
        _createElementVNode("div", {
          class: "agree-info-label",
          onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.showAgreeBox && _ctx.showAgreeBox(...args)), ["prevent"]))
        }, " 同意用户协议 ")
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "submit",
          class: "submit",
          disabled: !_ctx.agreed
        }, " 登 入 ", 8, _hoisted_18),
        _createElementVNode("button", {
          type: "button",
          class: "button",
          onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.doTrylogin && _ctx.doTrylogin(...args)), ["prevent"]))
        }, " 游客登入 ")
      ])
    ], 32)
  ]))
}